import React from 'react';
import Grid from '@material-ui/core/Grid';
import CardEstatisticasPessoais from './components/CardEstatisticaPessoais';
import CardEstatisticaTrapAmericano from './components/CardEstatisticaTrapAmericano';

export default function FiliadoRegisterEstatisticas(props) {
  const {
    filiado,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    setLoading,
    dadosVitrineEstatistica,
    dadosDetalhadosEstatisticasPessoas,
    dadosDetalhadosEstatisticasTrap,
  } = props;

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={6}
        sm={6}
        xs={12}
      >
        <CardEstatisticaTrapAmericano
          value={dadosVitrineEstatistica.totalDisparosTrap}
          filiado={filiado}
          dadosDetalhadosEstatisticasTrap={dadosDetalhadosEstatisticasTrap}
          setShowMessageSnack={setShowMessageSnack}
          setMessageSnack={setMessageSnack}
          setTypeSnack={setTypeSnack}
          setLoading={setLoading}
        />

      </Grid>
      <Grid
        item
        md={6}
        sm={6}
        xs={12}
      >
        <CardEstatisticasPessoais
          value={dadosVitrineEstatistica.valorTotalGasto}
          filiado={filiado}
          setShowMessageSnack={setShowMessageSnack}
          setMessageSnack={setMessageSnack}
          setTypeSnack={setTypeSnack}
          setLoading={setLoading}
          dadosDetalhadosEstatisticasPessoas={dadosDetalhadosEstatisticasPessoas}
        />
      </Grid>

    </Grid>
  );
}
